var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defineStore } from 'pinia';
import { nanoid } from 'nanoid';
var codeRemovedSharp = function (code) { return code.replace(/#/g, ''); };
var color = function (display) {
    var cCode = '';
    if (display === '01' || display === '09')
        cCode = 'grey';
    if (display === '02')
        cCode = 'red';
    return cCode;
};
export var useAcknowledgementStore = defineStore('acknowledgement', {
    state: function () { return ({
        acknowledgements: [],
    }); },
    getters: {
        snackbars: function (state) {
            return state.acknowledgements.filter(function (acknowledgement) { return acknowledgement.mode === 'snackbar'; });
        },
        signInSnackbar: function (state) {
            return state.acknowledgements.find(function (acknowledgement) { return acknowledgement.mode === 'signin_action_snackbar'; });
        },
        dialog: function (state) {
            return state.acknowledgements.find(function (acknowledgement) { return acknowledgement.mode === 'dialog'; });
        }
    },
    actions: {
        showAcknowledgement: function (res) {
            var _a, _b, _c, _d;
            if (res.code) {
                var newCode = codeRemovedSharp(res.code);
                var status_1 = (_a = newCode.charAt(0)) !== null && _a !== void 0 ? _a : '';
                var display = (_b = newCode.slice(1, 3)) !== null && _b !== void 0 ? _b : '';
                var timeout = 3000;
                var message = (_c = res.message) !== null && _c !== void 0 ? _c : '';
                var mode = null;
                if (display === '01')
                    mode = 'dialog'; // alert dialog
                if (display === '02')
                    mode = 'snackbar';
                if (display === '09')
                    mode = 'signin_action_snackbar';
                if (mode) {
                    var obj = {
                        id: nanoid(),
                        status: status_1,
                        mode: mode,
                        color: color(display),
                        timeout: timeout,
                        message: message,
                        to: (_d = res.to) !== null && _d !== void 0 ? _d : '',
                    };
                    this.acknowledgements.push(obj);
                }
            }
        },
        closeAcknowledgement: function (id) {
            var filtered = this.acknowledgements.filter(function (acknowledgement) { return acknowledgement.id !== id; });
            this.acknowledgements = filtered;
        },
        replaceAcknowledgement: function (id) {
            var filtered = this.acknowledgements.map(function (acknowledgement) {
                if (acknowledgement.id === id) {
                    var to = acknowledgement.to, rest = __rest(acknowledgement, ["to"]);
                    return rest;
                }
                return acknowledgement;
            });
            this.acknowledgements = filtered;
        },
        clearAcknowledgement: function () {
            this.acknowledgements = [];
        },
    },
    persist: true,
});
